import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SidebarMenuBlocks from "../../components/adminNavigation/SidebarMenuBlocks";
import Button from "../../components/form/Button";
import { useSelector } from "react-redux";
import logo_image from "../../assets/images/logo.png";
import icon from "../../assets/images/fav.png";
import { useTranslation } from "react-i18next";
import { rgba, toSnakeCase } from "../../helpers";

const AdminSideBar = ({ isMenuOpen, setMenuOpen = () => {}, isHeaderExpanded = false }) => {
  const { t } = useTranslation();
  const { session } = useSelector((state) => state?.authProvider);
  const message = useSelector((state) => state?.message);
  const { data } = useSelector((state) => state?.profile);
  const { appliedTheme, selectedElement, status } = useSelector((state) => state?.themeProvider);

  const adminSidebarMenu = [
    {
      _id: "dashboard",
      menuTitle: "Dashboard",
      menuData: [
        {
          _id: "dashboard",
          menuLabel: "Dashboard",
          menuLink: "/admin/dashboard",
          menuIcon: "fa-regular fa-grid-2",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-table-columns",
    },
    {
      _id: "Media",
      menuTitle: "Media",
      menuData: [
        {
          _id: "media",
          menuLabel: "List",
          menuLink: "/admin/media",
          menuIcon: "fa-regular fa-photo-film-music",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-photo-film-music",
    },
    {
      _id: "cryptocurrency",
      menuTitle: "Cryptocurrency",
      menuData: [
        {
          _id: "crypto currency",
          menuLabel: "List",
          menuLink: "/admin/crpto-list",
          menuIcon: "fas fa-arrow-trend-up",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fab fa-btc",
    },
    {
      _id: "users",
      menuTitle: "Users",
      menuData: [
        {
          _id: "users",
          menuLabel: "List",
          menuLink: "/admin/users",
          menuIcon: "fa-regular fa-users",
          menuIconColor: "text-primary",
        },
        {
          _id: "users-activity",
          menuLabel: "Activity",
          menuLink: "/admin/activity",
          menuIcon: "fa-regular fa-bolt",
          menuIconColor: "text-primary",
        },
        {
          _id: "users-role",
          menuLabel: "Roles",
          menuLink: "/admin/role",
          menuIcon: "fa-solid fa-user-shield",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-users-gear",
    },
    {
      _id: "blogs",
      menuTitle: "Blogs",
      menuData: [
        {
          _id: "blogs",
          menuLabel: "List",
          menuLink: "/admin/blogs",
          menuIcon: "fa-regular fa-blog",
          menuIconColor: "text-primary",
        },
        {
          _id: "blogs-category",
          menuLabel: "Categories",
          menuLink: "/admin/blog-categories",
          menuIcon: "fa-regular fa-layer-group",
          menuIconColor: "text-primary",
        },
        {
          _id: "blogs-tags",
          menuLabel: "Tags",
          menuLink: "/admin/blog-tags",
          menuIcon: "fa-regular fa-tags",
          menuIconColor: "text-primary",
        },
        // {
        //   _id: "blogs-comment",
        //   menuLabel: "Comments",
        //   menuLink: "/admin/blog-comments",
        //   menuIcon: "fa-regular fa-comments",
        //   menuIconColor: "text-primary",
        // },
      ],
      mainMenuIcon: "fa-regular fa-blog",
    },
    {
      _id: "jobs",
      menuTitle: "Careers",
      menuData: [
        {
          _id: "jobs",
          menuLabel: "List",
          menuLink: "/admin/jobs",
          menuIcon: "fa-regular fa-list",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-applications",
          menuLabel: "Applications",
          menuLink: "/admin/job-applications",
          menuIcon: "fa-regular fa-paper-plane",
          menuIconColor: "text-primary",
        },
        {
          _id: "jobs-departments",
          menuLabel: "Departments",
          menuLink: "/admin/job-departments",
          menuIcon: "fa-regular fa-sitemap",
          menuIconColor: "text-primary",
        },
        {
          _id: "jobs-category",
          menuLabel: "Categories",
          menuLink: "/admin/job-categories",
          menuIcon: "fa-regular fa-layer-group",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-skills",
          menuLabel: "Skills",
          menuLink: "/admin/job-skills",
          menuIcon: "fa-regular fa-lightbulb",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-experiences",
          menuLabel: "Experiences",
          menuLink: "/admin/job-experiences",
          menuIcon: "fa-regular fa-chart-line",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-qualifications",
          menuLabel: "Qualifications",
          menuLink: "/admin/job-qualifications",
          menuIcon: "fa-solid fa-award",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-salary-range",
          menuLabel: "Salary Range",
          menuLink: "/admin/job-salaryRange",
          menuIcon: "fas fa-money-bill-wave",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-products",
          menuLabel: "Tags",
          menuLink: "/admin/job-tags",
          menuIcon: "fa-regular fa-tags",
          menuIconColor: "text-primary",
        },
        {
          _id: "job-enquiry",
          menuLabel: "Enquiry",
          menuLink: "/admin/job-enquiry",
          menuIcon: "fa-regular fa-address-book",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-briefcase",
    },
    // {
    //   _id: "freelancer-jobs",
    //   menuTitle: "Freelancer Jobs",
    //   menuData: [
    //     {
    //       _id: "freelancer",
    //       menuLabel: "List",
    //       menuLink: "/admin/freelancer-jobs",
    //       menuIcon: "fa-regular fa-briefcase",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "jobs-freelancer-proposals",
    //       menuLabel: "Proposals",
    //       menuLink: "/admin/freelancer-proposals",
    //       menuIcon: "fa-regular fa-file-lines",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "jobs-freelancer-budgets",
    //       menuLabel: "Budgets",
    //       menuLink: "/admin/freelance-budgets",
    //       menuIcon: "fa-regular fa-display-chart-up-circle-currency",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "freelancer-category",
    //       menuLabel: "Categories",
    //       menuLink: "/admin/freelancer-categories",
    //       menuIcon: "fa-regular fa-layer-group",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "freelancer-tags",
    //       menuLabel: "Tags",
    //       menuLink: "/admin/freelancer-tags",
    //       menuIcon: "fa-regular fa-tags",
    //       menuIconColor: "text-primary",
    //     },
    //     {
    //       _id: "freelancer-enquiry",
    //       menuLabel: "Enquiry",
    //       menuLink: "/admin/freelance-enquiry",
    //       menuIcon: "fa-regular fa-address-book",
    //       menuIconColor: "text-primary",
    //     },
    //   ],
    //   mainMenuIcon: "fa-regular fa-users-line",
    // },

    {
      _id: "helps",
      menuTitle: "Helps",
      menuData: [
        {
          _id: "faq",
          menuLabel: "List",
          menuLink: "/admin/faq",
          menuIcon: "fa-regular fa-square-question",
          menuIconColor: "text-primary",
        },
        {
          _id: "faqs-category",
          menuLabel: "Categories",
          menuLink: "/admin/faqs-categories",
          menuIcon: "fa-regular fa-layer-group",
          menuIconColor: "text-primary",
        },
        // {
        //   _id: "faqs-tags",
        //   menuLabel: "Tags",
        //   menuLink: "/admin/faqs-tags",
        //   menuIcon: "fa-regular fa-tags",
        //   menuIconColor: "text-primary",
        // },
      ],
      mainMenuIcon: "fa-regular fa-person-circle-question",
    },
    {
      _id: "features",
      menuTitle: "Features",
      menuData: [
        {
          _id: "Services",
          menuLabel: "List",
          menuLink: "/admin/services",
          menuIcon: "fa-brands fa-servicestack",
          menuIconColor: "text-primary",
        },
        {
          _id: "services-category",
          menuLabel: "Categories",
          menuLink: "/admin/services-categories",
          menuIcon: "fa-regular fa-layer-group",
          menuIconColor: "text-primary",
        },
        {
          _id: "services-tags",
          menuLabel: "Tags",
          menuLink: "/admin/services-tags",
          menuIcon: "fa-regular fa-tags",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fas fa-bolt",
    },
    {
      _id: "plan&payment",
      menuTitle: "Plans & Payments",
      menuData: [
        {
          _id: "payments",
          menuLabel: "Orders",
          menuLink: "/admin/payments?tab=transactions",
          menuIcon: "fa-regular fa-bell",
          menuIconColor: "text-primary",
        },
        {
          _id: "taxs",
          menuLabel: "Taxes",
          menuLink: "/admin/tax",
          menuIcon: "fa-regular fa-receipt",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-money-bill-1-wave",
    },
    {
      _id: "Testimonials",
      menuTitle: "Testimonials",
      menuData: [
        {
          _id: "testimonial",
          menuLabel: "Testimonial",
          menuLink: "/admin/testimonial",
          menuIcon: "fa-regular fa-rectangle-history-circle-user",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-rectangle-history-circle-user",
    },
    {
      _id: "enquiry",
      menuTitle: "Enquiry",
      menuData: [
        {
          _id: "enquiry",
          menuLabel: "Enquiries",
          menuLink: "/admin/enquiry",
          menuIcon: "fa-regular fa-address-book",
          menuIconColor: "text-chestnut-rose",
        },
        {
          _id: "newsletter",
          menuLabel: "Newsletters",
          menuLink: "/admin/newsletter",
          menuIcon: "fa-regular fa-newspaper",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-file-lines",
    },
    {
      _id: "cms",
      menuTitle: "CMS",
      menuData: [
        {
          _id: "pages",
          menuLabel: "Pages",
          menuLink: "/admin/page",
          menuIcon: "fa-regular fa-file",
          menuIconColor: "text-primary",
        },
        {
          _id: "emails",
          menuLabel: "Email Templates",
          menuLink: "/admin/email-template",
          menuIcon: "fa-regular fa-envelope-open",
          menuIconColor: "text-primary",
        },
      ],
      mainMenuIcon: "fa-regular fa-folder-grid",
    },
    {
      _id: "settings",
      menuTitle: "Settings",
      menuData: [
        {
          _id: "settings",
          menuLabel: "Site Settings",
          menuLink: "/admin/site-settings",
          menuIcon: "fa-regular fa-gear",
          menuIconColor: "text-primary",
        },
        // {
        //   _id: "organization",
        //   menuLabel: "Organization",
        //   menuLink: "/admin/organization",
        //   menuIcon: "fa-regular fa-building",
        //   menuIconColor: "text-primary",
        // },
      ],
      mainMenuIcon: "fa-regular fa-gear-complex",
    },
  ];

  const [expandedMenuId, setExpandedMenuId] = useState(null);

  const handleToggle = (id) => {
    setExpandedMenuId((prevId) => (prevId === id ? null : id));
  };

  useEffect(() => {
    // if (adminSidebarMenu.length > 0) {
    //   setExpandedMenuId(adminSidebarMenu[0]._id);
    // }
    const firstExpandableMenu = adminSidebarMenu.find((item) => item.menuData?.length > 1);
    if (firstExpandableMenu) {
      setExpandedMenuId(firstExpandableMenu._id);
    }
  }, []);

  return (
    <div className="relative w-full bg-[#0A0C03]">
      <div
        className={`relative py-4 flex items-center gap-4 transition-all duration-100 z-60 border-slate-700` + (isMenuOpen ? "px-3" : "px-3")}
        {...(appliedTheme?.customiseLogo?.backgroundColor && {
          style: {
            backgroundColor: "rgba(appliedTheme?.customiseLogo?.backgroundColor)",
          },
        })}
      >
        <Link className="h-12  mx-auto " to={"/"} replace>
          <img
            className="w-full h-full object-contain"
            src={appliedTheme?.logo instanceof File ? URL.createObjectURL(appliedTheme?.logo) : appliedTheme?.logo?.url || appliedTheme?.logo}
            alt={"Logo"}
          />
        </Link>
      </div>
      <div
        className={`relative overflow-auto scroll-smooth scrollbar scrollbar-1 transition-all duration-200 px-1 bg-[#0A0C03] ${
          isHeaderExpanded ? "max-h-[calc(100vh-26rem)]" : "max-h-[calc(100vh-16rem)]"
        }`}
      >
        {Array.isArray(adminSidebarMenu) &&
          adminSidebarMenu?.map((item, index) => {
            if (item) {
              return (
                <SidebarMenuBlocks
                  key={item._id}
                  menuTitle={item.menuTitle}
                  menuData={item.menuData}
                  mainMenuIcon={item?.mainMenuIcon}
                  isMenuOpen={isMenuOpen}
                  isExpanded={expandedMenuId === item._id}
                  onToggle={() => setExpandedMenuId((prev) => (prev === item._id ? null : item._id))}
                />
              );
            }
            return null;
          })}
      </div>
    </div>
  );
};

export default AdminSideBar;
